import styled from 'styled-components';

export const Item = styled.div`
  position: relative;
`;

export const Content = styled.div`
  margin: 0 0 15px;
  /* display: flex; */
  /* gap: 10px; */
  /* justify-content: space-between; */
  /* align-items: center; */
  /* flex-wrap: wrap; */
  display: grid;
  grid-template-columns: 6fr 5fr; /* 2 колонки */
  grid-template-rows: 1fr 1fr; /* 2 строки */
  gap: 10px;

  & > div {
    height: 30px;

    & > button {
      width: 100%;
      height: 100%;
      img {
        margin-right: 10px;
      }
    }
    &.big {
      grid-row: span 2;
      & > button:first-of-type {
        height: 70px;
        font-size: 15px;
        line-height: normal;
      }
    }
  }
`;
